import LearningObjectList from "./LearningObjectList";

export default LearningObjectList;
